import { render, staticRenderFns } from "./Specialties.vue?vue&type=template&id=65a0a158&lang=pug&"
import script from "./Specialties.vue?vue&type=script&lang=ts&"
export * from "./Specialties.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports